import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Checkbox, Grid, Select, TextField, Typography, makeStyles } from '@material-ui/core';
import { createDeviceUpdate, fetchDeviceUpdates } from '../../actions/deviceUpdateActions';
import { Autocomplete } from '@material-ui/lab';
import { useDispatch } from 'react-redux';
import { fetchDevice } from '../../actions/deviceActions';
import { fetchUserAlerts, fetchUserAlertSettings, updateUserAlertsSettings } from '../../actions/alertActions';
import { USER_ALERT_TYPES } from '../../util/constants';


const useStyles = makeStyles({
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  checkbox: {
    paddingLeft: 0
  }
});


export default function AlertSettingModal(props) {
  const { groups, settings, groupSettings } = props;
  const [open, setOpen] = useState(false);
  const [updatedSettings, setUpdatedSettings] = useState(settings);
  const [ignoredGroupNames, setIgnoredGroupNames] = useState([]);
  const [groupNames, setGroupNames] = useState([]);
  const [groupMap, setGroupMap] = useState({});
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleSave = async () => {
    await updateUserAlertsSettings(updatedSettings, ignoredGroupNames.map((groupName) => { 
      return { deviceGroupId: groupMap[groupName], ignore: true }
    }));
    dispatch(fetchUserAlertSettings());
    setOpen(false);
  }

  const updateSettings = (key, value) => {
    setUpdatedSettings({
      ...updatedSettings,
      [key]: value
    });
  }

  useEffect(() => {
    if (groups) {
      setGroupNames(groups.map((group) => group.group_name));
      const newGroupMap = {};
      for (const group of groups) {
        newGroupMap[group.group_name] = group.group_id;
      }
      setGroupMap(newGroupMap);
    }
  }, [groups]);

  useEffect(() => {
    if (settings) {
      setUpdatedSettings(settings);
    }
  }, [settings]);

  useEffect(() => {
    if (groupSettings && groups) {
      const newGroupMap = {};
      const newIgnoredGroupNames = [];
      for (const group of groups) {
        newGroupMap[group.group_id.toString()] = group.group_name;
      }
      for (const group of groupSettings) {
        newIgnoredGroupNames.push(newGroupMap[group.groupId.toString()]);
      }
      setIgnoredGroupNames(newIgnoredGroupNames);
    }
  }, [groupSettings, groups]);

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        onClick={() => {
          setOpen(true);
        }}
      >
        Alert Settings
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>
          Alert Settings
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div className={classes.checkboxContainer}>
                <Checkbox
                  className={classes.checkbox}
                  checked={updatedSettings && updatedSettings[USER_ALERT_TYPES.SPYPOINT_ERROR]}
                  onChange={(event) => updateSettings(USER_ALERT_TYPES.SPYPOINT_ERROR, event.target.checked)}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
                <Typography variant='body1'>Monitor Spypoint Cable Errors?</Typography>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.checkboxContainer}>
                <Checkbox
                  className={classes.checkbox}
                  checked={updatedSettings && updatedSettings[USER_ALERT_TYPES.LOW_BATTERY]}
                  onChange={(event) => updateSettings(USER_ALERT_TYPES.LOW_BATTERY, event.target.checked)}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
                <Typography variant='body1'>Monitor Low Battery Errors?</Typography>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.checkboxContainer}>
                <Checkbox
                  className={classes.checkbox}
                  checked={updatedSettings && updatedSettings[USER_ALERT_TYPES.NO_RECENT_INSIGHTS]}
                  onChange={(event) => updateSettings(USER_ALERT_TYPES.NO_RECENT_INSIGHTS, event.target.checked)}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
                <Typography variant='body1'>Monitor Devices with No Recent Insights?</Typography>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.checkboxContainer}>
                <Checkbox
                  className={classes.checkbox}
                  checked={updatedSettings && updatedSettings[USER_ALERT_TYPES.NO_RECENT_CAMERA_TRIGGERS]}
                  onChange={(event) => updateSettings(USER_ALERT_TYPES.NO_RECENT_CAMERA_TRIGGERS, event.target.checked)}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
                <Typography variant='body1'>Monitor Devices with No Recent Camera Triggers?</Typography>
              </div>
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                onChange={(event, value) => setIgnoredGroupNames(value)}
                multiple
                value={ignoredGroupNames}
                options={groupNames}
                renderInput={(params) => <TextField required {...params} label="Ignored Device Groups" />}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={handleSave}
            variant="contained"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
